import { render, staticRenderFns } from "./loginNuevo.vue?vue&type=template&id=267f4c1c&scoped=true&"
import script from "./loginNuevo.vue?vue&type=script&lang=js&"
export * from "./loginNuevo.vue?vue&type=script&lang=js&"
import style0 from "./loginNuevo.vue?vue&type=style&index=0&id=267f4c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f4c1c",
  null
  
)

export default component.exports